
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hairstraightener/contact-us",
      function () {
        return require("private-next-pages/hairstraightener/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hairstraightener/contact-us"])
      });
    }
  